import { DonatePage } from "@components/donate/DonateV3/PaymentProcess/pages/Donate";
import { DonateFormContext } from "@components/donate/DonateV3/PaymentProcess/useDonateFormContext";
import { DonateFormType } from "@components/donate/DonateV3/types";
import { useLayoutEffect } from "react";
import { UseFormReturn } from "react-hook-form";

import { FundraiserResponse } from "@every.org/common/src/codecs/entities";
import {
  DonationFlowPaymentOption,
  DonationFrequency,
} from "@every.org/common/src/entity/types";

import { ContextNonprofit } from "src/context/NonprofitsContext/types";

export const IraPage = ({
  form,
  formContext,
  nonprofit,
  fundraiser,
}: {
  form: UseFormReturn<DonateFormType>;
  formContext: DonateFormContext;
  nonprofit: ContextNonprofit;
  fundraiser?: FundraiserResponse | null;
}) => {
  const frequency = form.watch("frequency");
  const paymentRequestPaymentMethodId = form.watch(
    "paymentRequestPaymentMethodId"
  );
  const paymentSource = form.watch("paymentSource");
  const paymentSourceType = form.watch("paymentSourceType");

  // IRA currently supports only one-time pledges. Clear any stale payment
  // source fields retained from switching payment options before CHECK submit,
  // including form state that can become externalPaymentSourceId.
  // https://github.com/everydotorg/every.org/issues/20607
  useLayoutEffect(() => {
    if (frequency !== DonationFrequency.ONCE) {
      form.setValue("frequency", DonationFrequency.ONCE);
    }
    if (paymentRequestPaymentMethodId !== undefined) {
      form.setValue("paymentRequestPaymentMethodId", undefined);
    }
    if (paymentSource !== undefined) {
      form.setValue("paymentSource", undefined);
    }
    if (paymentSourceType !== undefined) {
      form.setValue("paymentSourceType", undefined);
    }
  }, [
    form,
    frequency,
    paymentRequestPaymentMethodId,
    paymentSource,
    paymentSourceType,
  ]);

  return (
    <DonatePage
      form={form}
      formContext={formContext}
      nonprofit={nonprofit}
      fundraiser={fundraiser}
      paymentOption={DonationFlowPaymentOption.IRA}
    />
  );
};
